<template>
  <d-modal
    :class="{ 'is-hidden': isHidden }"
    @close="handleClose">
    <d-modal-header>
      <template v-if="editMode">Edycja osoby kontaktowej</template>
      <template v-else>Dodawanie osoby kontaktowej</template>
    </d-modal-header>
    <d-modal-body>
      <d-form>
        <d-container class="pl-0 pr-0">
          <validation-observer
            ref="client-contact-person-form"
            tag="form">
            <d-row>
              <d-col
                lg="6"
                md="6">
                <div class="form-group">
                  <label for="name"> Imię: </label>

                  <validation-provider
                    rules="required"
                    name="name"
                    v-slot="{ errors }">
                    <d-input
                      :state="errors.length ? 'invalid' : null"
                      v-model="name"/>
                    <div class="invalid-feedback">
                      {{ errors[0] }}
                    </div>
                  </validation-provider>
                </div>
              </d-col>
              <d-col
                lg="6"
                md="6">
                <div class="form-group">
                  <label for="surname"> Nazwisko: </label>

                  <validation-provider
                    rules="required"
                    name="surname"
                    v-slot="{ errors }">
                    <d-input
                      :state="errors.length ? 'invalid' : null"
                      v-model="surname"/>
                    <div class="invalid-feedback">
                      {{ errors[0] }}
                    </div>
                  </validation-provider>
                </div>
              </d-col>
            </d-row>
            <d-row>
              <d-col
                lg="6"
                md="6">
                <div class="form-group">
                  <label for="email"> Adres e-mail: </label>

                  <validation-provider
                    name="email"
                    type="email"
                    :rules="isEmailRequired ? 'required|email' : 'email'"
                    v-slot="{ errors }">
                    <d-input
                      type="email"
                      :state="errors.length ? 'invalid' : null"
                      v-model="email"/>
                    <div class="invalid-feedback">
                      {{ errors[0] }}
                    </div>
                  </validation-provider>
                </div>
              </d-col>

              <d-col
                lg="6"
                md="6">
                <div class="form-group">
                  <label for="phone"> Telefon kontaktowy: </label>

                  <validation-provider
                    name="phone"
                    :rules="{ required: isPhoneRequired }"
                    v-slot="{ errors }">
                    <d-input
                      :state="errors.length ? 'invalid' : null"
                      v-model="phone"/>
                    <div class="invalid-feedback">
                      {{ errors[0] }}
                    </div>
                  </validation-provider>
                </div>
              </d-col>
            </d-row>
            <div class="form-group">
              <label for="notes"> Notatka: </label>

              <validation-provider
                name="notes"
                v-slot="{ errors }">
                <d-form-textarea
                  :state="errors.length ? 'invalid' : null"
                  :rows="3"
                  v-model="notes"
                  :value.prop="notes">
                </d-form-textarea>
                <div class="invalid-feedback">
                  {{ errors[0] }}
                </div>
              </validation-provider>
            </div>
          </validation-observer>
        </d-container>
      </d-form>
    </d-modal-body>
    <d-modal-footer>
      <d-button
        class="ml-0"
        theme="danger"
        @click.prevent="cancel">
        Anuluj
      </d-button>
      <d-button
        class="ml-auto"
        theme="success"
        :disabled="submitInProgress"
        @click.prevent="validateForm">
        <div
          v-if="submitInProgress"
          class="spinner-border spinner-border-sm"
          role="status">
        </div>
        <template v-if="editMode">Zapisz zmiany</template>
        <template v-else>Dodaj</template>
      </d-button>
    </d-modal-footer>
  </d-modal>
</template>

<script>
import FormUtils from './../../utils/FormUtils.js';

export default {
  name: 'client-contact-person-popup',
  computed: {
    isEmailRequired () {
      return this.phone === '' || this.phone === null;
    },
    isPhoneRequired () {
      return this.email === '' || this.email === null;
    }
  },
  data() {
    return {
      id: null,
      name: '',
      surname: '',
      email: '',
      phone: '',
      notes: '',
      isHidden: true,
      submitInProgress: false,
      referrerID: null,
      editMode: false,
    };
  },
  mounted() {
    this.$bus.$on('client-contact-person-popup-show', this.openPopup);
  },
  methods: {
    handleClose() {
      this.isHidden = true;
    },
    validateForm() {
      FormUtils.validate(this.$refs['client-contact-person-form'], this.save);
    },
    save() {
      this.submitInProgress = true;

      let params = {
        name: this.name,
        surname: this.surname,
        email: this.email,
        phone: this.phone,
        notes: this.notes,
        customer_id: this.referrerID,
      };

      let endpointUrl = '/api/contacts/contacts/store';

      if (this.editMode) {
        endpointUrl = '/api/contacts/contacts/update/' + this.id;
      }

      FormUtils.submit(this, {
        endpoint: endpointUrl,
        formData: params,
        successTitle: 'Zapisano kontakt',
        successText: 'Wybrany kontakt został zapisany',
        errorTitle: 'Wystąpił błąd',
        errorText:
          'Modyfikacja danych kontaktu nie powiodła się. Spróbuj ponownie.',
        successAction: () => {
          this.submitInProgress = false;
          this.$bus.$emit('client-contact-person-added');
          this.handleClose();
        },
        failAction: () => {
          this.submitInProgress = false;
        },
      });
    },
    openPopup(clientId, contactData = false) {
      this.referrerID = clientId;
      this.editMode = !!contactData;

      if (this.editMode) {
        this.id = contactData.id;
        this.name = contactData.name;
        this.surname = contactData.surname;
        this.email = contactData.email;
        this.phone = contactData.phone;
        this.notes = contactData.notes;
      } else {
        this.id = null;
        this.name = '';
        this.surname = '';
        this.email = '';
        this.phone = '';
        this.notes = '';
      }

      setTimeout(() => {
        this.isHidden = false;
        if (this.$refs['client-contact-person-form']) {
          this.$refs['client-contact-person-form'].reset();
        }
      }, 0);
    },
    cancel() {
      this.handleClose();
    },
  },
  beforeDestroy () {
    this.$bus.$off('client-contact-person-popup-show', this.openPopup);
  }
};
</script>

<style lang="scss" scoped>
.modal.is-hidden {
  display: none;
  pointer-events: none;
}
</style>
